module.exports = __webpack_public_path__ + "static/kitchen-app-1-bbfbf9547333a7dc3252ebdf8db24866.png";